import styled from 'styled-components';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { useNavigate } from 'react-router-dom';
import { useQueryParamsHook } from '../../../../../utils/useQueryParamsHook';
import { useApiInfoContextValueHook } from '../../../../../contexts/ApiInfoContext';
import { ViewType } from '../../variables/ViewType';
import { useSelectedCoupangApiStoreInfosValueContextHook } from '../../contexts/SelectedCoupangApiStoreInfosContext';
import { customToast } from '../../../../../components/toast/custom-react-toastify/v1';
import { SellertoolSignatureUtils } from '../../../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import { CoupangApiApi } from '../../../../../apis/CoupangApiApi';
import { useCollectedOrderDatasActionsContextHook } from '../../contexts/CollectedOrderDatasContext';

const ScContainer = styled.div`
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const ScButton = styled(CustomBlockButton)`
    background-color: #333;
    color: #fff;
    font-weight: 600;
    border-radius: 3px;

    &.collected{
        background: #fff;
        color: #333;
        border-color: #333;
    }
`;

export function WegetMainCollectionButton(props) {
    const navigate = useNavigate();
    const queryParamsHook = useQueryParamsHook();
    const selectedCoupangApiStoreInfosValueContextHook = useSelectedCoupangApiStoreInfosValueContextHook();
    const collectedOrderDatasActionsContextHook = useCollectedOrderDatasActionsContextHook();

    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const handleFulfillCollection = async () => {
        if (selectedCoupangApiStoreInfosValueContextHook.coupangApiStoreInfos?.length <= 0) {
            customToast.error('주문수집할 스토어를 선택해주세요.');
            return;
        }

        queryParamsHook.setSearchParams({ ViewType: ViewType.COLLECTED }, { replace: false });

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            coupangApiStoreInfoIds: selectedCoupangApiStoreInfosValueContextHook.coupangApiStoreInfos.map(storeInfo => storeInfo.id)
        }

        CustomBackdropController().showBackdrop();
        const result = await CoupangApiApi().collectOrders({ body: body, headers: headers });
        console.log(result);
        if (!result?.content) {
            navigate(-1);
        }
        if (result?.content) {
            collectedOrderDatasActionsContextHook.collectedOrderDatas.onSet(result?.content);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleMoveToCollected = () => {
        queryParamsHook.setSearchParams({ ViewType: ViewType.COLLECTED }, { replace: false });
    }

    return (
        <>
            <ScContainer>
                <ScButton
                    type='button'
                    onClick={() => handleFulfillCollection()}
                >
                    주문수집
                </ScButton>
                <ScButton
                    type='button'
                    onClick={() => handleMoveToCollected()}
                    className='collected'
                >
                    수집현황
                </ScButton>
            </ScContainer>
        </>
    );
}